import { useId } from 'react';
import type { HistoricoDeProduto } from '../../api/movimentacoes.js';
import type { Consulta } from '../../api/useConsulta.js';
import { formatarDataHora } from '../../componentes/datas.js';
import { rotuloDoLocal } from '../../componentes/deposito.js';
import './DepositoAtual.css';

/**
 * Em que depósito o produto está agora, em destaque (UC11 passo 2).
 *
 * É a resposta que o supervisor foi buscar; a trilha abaixo explica como ele
 * chegou lá. Depósito desconhecido é dito com todas as letras — chutar o
 * último conhecido mandaria alguém ao depósito errado.
 */
export function DepositoAtual({ consulta }: { readonly consulta: Consulta<HistoricoDeProduto> }) {
  const idTitulo = useId();
  const historico = consulta.dados;

  return (
    <section className="deposito-atual" aria-labelledby={idTitulo}>
      <h2 className="deposito-atual__titulo" id={idTitulo}>
        Depósito atual
      </h2>

      {consulta.erro !== null && (
        <p className="deposito-atual__aviso deposito-atual__aviso--erro" role="alert">
          {consulta.erro}
        </p>
      )}

      {consulta.erro === null && historico === null && (
        <p className="deposito-atual__aviso" role="status">
          Consultando o depósito atual…
        </p>
      )}

      {historico !== null && historico.depositoAtual === null && (
        <p className="deposito-atual__vazio">Depósito atual desconhecido</p>
      )}

      {historico !== null && historico.depositoAtual !== null && (
        <>
          <p className="deposito-atual__valor">
            {rotuloDoLocal(historico.filialAtual, historico.depositoAtual)}
          </p>
          <p className="deposito-atual__quando">
            Atualizado em {formatarDataHora(historico.atualizadoEm)}
          </p>
        </>
      )}
    </section>
  );
}
